import { List,Map, Record } from "immutable";

import syncDocumentTypes from "../../../constants/syncDocumentTypes";
import createFromJS from "../../createFromJS";

export const SyncDocumentRecord = Record({
  id: null,
  type: syncDocumentTypes.TEXT,
  itemType: null,
  label: null,
  properties: Map(),
  keywords: List()
});

const data = {
  objects: {
    properties: "Map",
    keywords: "List"
  }
};
createFromJS.registerCallback("SyncDocumentRecord", createFromJS.createNestedCallback(SyncDocumentRecord, data));
